import React, { useEffect, useRef, useState } from 'react';
import { SUBTYPES_FBO } from '../../../../config';
import Button from '../../../common/Button';
import { useDispatch } from 'react-redux';
import { fetchGetAdminSubtypesFbo } from '../../../../actions/admin.js';
import List from './components/List.jsx';
import Info from './components/Info.jsx';

const SubtypesFbo = (props) => {
  const { values } = props;
  const targetElement = useRef();
  const [mode, setMode] = useState(SUBTYPES_FBO.LIST);
  const [options, setOptions] = useState([]);
  const [option, setOption] = useState(null);
  const [subtypes, setSubtype] = useState([]);
  const [currentType, setCurrentType] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchGetAdminSubtypesFbo());
  }, []);
  useEffect(() => {
    if (values?.subtypesFbo) {
      setOptions(values?.subtypesFbo?.map((el) => ({ value: el?.code, label: el?.name })));
    }
  }, [values?.subtypesFbo]);

  useEffect(() => {
    if (!option) return;
    const type = values?.subtypesFbo.find((el) => el.code === option);
    setSubtype(type.subtypes || []);
  }, [option, values?.subtypesFbo]);

  const handleSwitchMode = (mode, value) => {
    if (value) {
      setCurrentType(value);
    }
    setMode(mode);

    const el = targetElement;
    el.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  };

  const displaySubtypeComponent = () => {
    switch (mode) {
      case SUBTYPES_FBO.LIST:
        return (
          <List
            values={values}
            options={options}
            option={option}
            setOption={setOption}
            setOptions={setOptions}
            subtypes={subtypes}
            handleSwitchMode={handleSwitchMode}
          />
        );
      case SUBTYPES_FBO.INFO:
      case SUBTYPES_FBO.EDIT:
        return (
          <Info
            handleSwitchMode={handleSwitchMode}
            mode={mode}
            item={currentType}
            option={option}
            setCurrentType={setCurrentType}
          />
        );

      default:
        return <p>Загрузка</p>;
    }
  };
  return (
    <div ref={targetElement}>
      <div
        className="border-bottom"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: '20px',
          marginBottom: '20px',
        }}
      >
        <h4 className="header-title">ФБО подтипы</h4>

        {mode === SUBTYPES_FBO.LIST && option && (
          <Button text="Создать" onClick={() => handleSwitchMode(SUBTYPES_FBO.INFO, null)} />
        )}
      </div>
      {displaySubtypeComponent()}
    </div>
  );
};
export default SubtypesFbo;
